import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * 
 * Automatically scrolls to top on every route change.
 * Uses useLayoutEffect for synchronous scroll before paint.
 * 
 * Works with:
 * - Header navigation links
 * - Footer links  
 * - Category/filter links
 * - Product links
 * - Breadcrumbs
 * - Pagination
 * - Browser back/forward
 */
const ScrollToTop = () => {
  const { pathname, search, key } = useLocation();

  // Use useLayoutEffect for synchronous scroll before browser paint
  useLayoutEffect(() => {
    // Scroll to absolute top
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, search, key]);

  // Backup scroll after render in case layout shifts occur
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => clearTimeout(timer);
  }, [pathname, search, key]);

  return null;
};

export default ScrollToTop;
